<template>
  <div class="filter__buttons">
    <AppButton
      title="Показать"
      type="main"
    />

    <AppButton
      title="Сбросить"
      type="alt"
      @click.prevent.native="$emit('reset')"
    />
  </div>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'

export default {
  name: 'FilterButtonGroup',
  components: {
    AppButton
  }
}
</script>
